<template>
    <div>
        <nav-summary/>
        <nav-recommended/>
        <nav-menu/>
        <header class="header">
            <div class="header__text-box">
                <h1 class="heading-primary">
                    <span class="heading-primary--main">Articles</span>
                    <span class="u-margin-bottom-big heading-primary--sub">of interest</span>
                    <label for="mySentence"/>
                    <input v-model="mySentence" id="mySentence" style="display: none;">
                    <span>{{mySentence}}</span>
                </h1>
            </div>
        </header>
    </div>

</template>

<script>
    import NavMenu from '@/components/NavMenu'
    import NavSummary from '@/components/NavSummary'
    import NavRecommended from '@/components/NavRecommended'

    export default {
        components: {
            NavMenu,
            NavSummary,
            NavRecommended
        },
        data() {
            return {
                mySentence: 'In Programming & Data Science',
            }
        },
        created() {
        },
        methods: {}
    }
</script>

<style scoped>

</style>
